<h1 mat-dialog-title [attr.data-cy]="'taapdaapd_h1_1_4_'">Tourenplan Artikel</h1>
<div mat-dialog-content>
    <kiene-article-scan-autocomplete
        #articleAuto
        [placeholder]="'Artikel'"
        (selectedMaterial)="setSelectedMaterial($event)"
        [gesperrtAusblenden]="true"
    ></kiene-article-scan-autocomplete>

    <mat-form-field>
        <mat-label>Menge</mat-label>
        <input
            #menge="matInput"
            matInput
            type="number"
            min="0.0001"
            [max]="maxArtikelmenge"
            step="any"
            [formControl]="mengeCtrl"
            (keyup.enter)="anzahlTiere?.focus()"
            [attr.data-cy]="'taapdaapd_input_2_1_'"
        />
        <mat-error *ngIf="mengeCtrl.hasError('required')">Menge ist Pflicht</mat-error>
        <mat-error *ngIf="mengeCtrl.hasError('min')">Menge muss größer als 0 sein</mat-error>
        <mat-error *ngIf="mengeCtrl.hasError('max')"
            >Max. {{ maxArtikelmenge }} (vermutlich Barcode statt Menge)</mat-error
        >
    </mat-form-field>

    <mat-form-field>
        <mat-label>Anzahl Tiere</mat-label>
        <input
            #anzahlTiere="matInput"
            matInput
            type="number"
            [formControl]="anzahlTiereCtrl"
            (keyup.enter)="identifikation?.focus()"
            [attr.data-cy]="'taapdaapd_input_3_1_'"
        />
    </mat-form-field>

    <mat-form-field>
        <mat-label>Identifikation</mat-label>
        <input
            #identifikation="matInput"
            matInput
            type="text"
            [formControl]="identifikationCtrl"
            (keyup.enter)="save()"
            [attr.data-cy]="'taapdaapd_input_4_1_'"
        />
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="cancel()" [attr.data-cy]="'taapdaapd_button_1_0_'">Abbrechen</button>
    <button
        mat-flat-button
        color="accent"
        (click)="save()"
        [disabled]="!currentArtikelMenge.article || mengeCtrl.invalid"
        [attr.data-cy]="'taapdaapd_button_2_0_'"
        >&Uuml;bernehmen
    </button>
</div>
